import React, { useEffect, useState } from "react";

import ConfigDialog from "@shared/ConfigDialog";

interface BuildConfigDialogProps {
    open: boolean;
    product: API.Product | null;
    onClose: () => void;
}

const BuildConfigDialog: React.FC<BuildConfigDialogProps> = ({ open, onClose, product }) => {
    const [currentProduct, setCurrentProduct] = useState<API.Product | null>(null);

    useEffect(() => {
        if (open && product) {
            setCurrentProduct(product);
        }
    }, [open, product]);

    return <ConfigDialog open={open} configData={currentProduct?.customBuildConfig ?? null} onClose={onClose} />;
};

export default BuildConfigDialog;
